module.exports = __webpack_public_path__ + "c8bcbb7a7d10809c8bef8b4cc2f991c3.png";